/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createReservationsRepository = (options: RestApiOptions): Types.ReservationsRepository => ({
    async getPrices(params, requestOptions) {
        return options.request('/reservations/getPrices', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getPricing(params, requestOptions) {
        return options.request('/reservations/getPricing', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async price(params, requestOptions) {
        return options.request('/reservations/price', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
